import { isEmpty } from "../gui_components/Util.js";
import { ServiceExecutorProxy } from "./ServiceExecutorProxy.js";
export class ReportService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.report_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_REPORT_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static inquireAllFabricStyleATSInfos(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireAllFabricStyleATSInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerOnOrderATSSummaryDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerOnOrderATSSummaryDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerSalesOnOrderDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerSalesOnOrderDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static geCustomerOnOrderATSSummary(input, responseCallBack, errorCallBack) {
    this.method(
      "geCustomerOnOrderATSSummary",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateVendorOnOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateVendorOnOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorSummaryOnOrderATSDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorSummaryOnOrderATSDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorSummaryOnOrderATSQuantities(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorSummaryOnOrderATSQuantities",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchInventoryPageListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchInventoryPageListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchInventorySummaryDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchInventorySummaryDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorPurchaseOrderInTransitDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorPurchaseOrderInTransitDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForLast3MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForLast6MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForLast12MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForLast18MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForLast24MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForLast36MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForLast36MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePopUpLastSalesDetailsATSPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePopUpLastSalesDetailsATSPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAllFabricStyleATSInfoDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAllFabricStyleATSInfoDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateVendorInTransitPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateVendorInTransitPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePurchaseOrderInTransitInfosPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePurchaseOrderInTransitInfosPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInTransitSummaryDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInTransitSummaryDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleWeeklyMonthlyATSResults(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleWeeklyMonthlyATSResults",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesOrderPrintReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateSalesOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricOnOrderDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricOnOrderDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePurchaseOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePurchaseOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePurchaseOrderReceiptPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePurchaseOrderReceiptPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printPickTicketBoxShipmentLabel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "printPickTicketBoxShipmentLabel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printPickTicketAllBoxShipmentLabels(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "printPickTicketAllBoxShipmentLabels",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInvoicePrintReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateInvoicePrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateMultiRollSkuEntityPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateMultiRollSkuEntityPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickTicketPrintReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generatePickTicketPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInTransitPackingListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInTransitPackingListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleSoldToCustomerInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleSoldToCustomerInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireInvoiceRegisterReport(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireInvoiceRegisterReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInvoiceRegisterPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInvoiceRegisterPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleSoldToCustomerPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleSoldToCustomerPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerBalanceDetailsHistory(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCustomerBalanceDetailsHistory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerBalanceDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerBalanceDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireBankAccountBalanceHistoryTrack(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireBankAccountBalanceHistoryTrack",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePastDueInvoiceWithCCPayment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePastDueInvoiceWithCCPayment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePastDueInvoiceWithCCPayment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePastDueInvoiceWithCCPayment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerPaymentCurrentAgingHistory(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCustomerPaymentCurrentAgingHistory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerPaymentCurrentAgingHistoryReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerPaymentCurrentAgingHistoryReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerAgingOpenInvoicesPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerAgingOpenInvoicesPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireAllCustomerOnlineAging(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireAllCustomerOnlineAging",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAllCustomerOnlineAgingReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAllCustomerOnlineAgingReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePostedARRegister(input, responseCallBack, errorCallBack) {
    this.method(
      "inquirePostedARRegister",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePostedARRegisterPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePostedARRegisterPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePostDatedAndBouncedCheckDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePostDatedAndBouncedCheckDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePostDatedAndBouncedCheckPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePostDatedAndBouncedCheckPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePostedARPaymentRegister(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePostedARPaymentRegister",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePostedARPaymentRegisterPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePostedARPaymentRegisterPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCheckPaymentHistoryReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCheckPaymentHistoryReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCheckPaymentHistoryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCheckPaymentHistoryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getBinInventoryPageListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getBinInventoryPageListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getBinInventoryForInventoryAdjustmentPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getBinInventoryForInventoryAdjustmentPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireMultiInfoPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireMultiInfoPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricInfoListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricInfoListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerInfoListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerInfoListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateVendorInfoListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateVendorInfoListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireProductAvailabilityResults(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireProductAvailabilityResults",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateProductAvailabilityDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateProductAvailabilityDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateYearlyStasticsSalesAnalysisReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateYearlyStasticsSalesAnalysisReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerStatisticsData(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireCustomerStatisticsData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerStatisticsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerStatisticsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireVendorStatisticsData(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireVendorStatisticsData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateVendorStatisticsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateVendorStatisticsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getUnApprovedPurchaseOrders(input, responseCallBack, errorCallBack) {
    this.method(
      "getUnApprovedPurchaseOrders",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateunApprovedPurchaseOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateunApprovedPurchaseOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStylePurchaseOrderHistoryInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStylePurchaseOrderHistoryInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStylePurchaseOrderHistoryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStylePurchaseOrderHistoryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePurchaseOrderInTransitInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePurchaseOrderInTransitInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePurchaseOrderInTransitInfosPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePurchaseOrderInTransitInfosPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseReceiptReceivedDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseReceiptReceivedDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePurchaseOrderReceiptInquiryReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePurchaseOrderReceiptInquiryReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getReceiptRollsBinLocations(input, responseCallBack, errorCallBack) {
    this.method(
      "getReceiptRollsBinLocations",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateReceiptBinRollsBinLocationSummaryReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateReceiptBinRollsBinLocationSummaryReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getReceiptRollDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getReceiptRollDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateMultiInTransitRollSkuEntityPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateMultiInTransitRollSkuEntityPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateBouncedChecksPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateBouncedChecksPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireBouncedChecksDetail(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireBouncedChecksDetail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireUnPostedARList(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireUnPostedARList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateUnPostedARListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateUnPostedARListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAllCustomerTransactionData(input, responseCallBack, errorCallBack) {
    this.method(
      "getAllCustomerTransactionData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateBatchInventorySummaryDataPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateBatchInventorySummaryDataPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSkubatchInventoryTrackPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSkubatchInventoryTrackPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerTransactionSummaryData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerTransactionSummaryData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireAllCustomersPaymentCurrentAgingHistory_V1(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireAllCustomersPaymentCurrentAgingHistory_V1",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireMultiCustomersOnlineAging(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireMultiCustomersOnlineAging",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateMultiCustomersOnlineAgingPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateMultiCustomersOnlineAgingPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePopupAllCustomerDueDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePopupAllCustomerDueDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePopupAllCustomerCreditMemoDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePopupAllCustomerCreditMemoDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAllCustomerTransactionGeneralReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAllCustomerTransactionGeneralReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePopupCustomerTransactionCreditMemoDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePopupCustomerTransactionCreditMemoDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderReceiptDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCheckTransactionPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCheckTransactionPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printPickTicketRollAndRollSkuLabels(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "printPickTicketRollAndRollSkuLabels",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePackingListPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePackingListPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerAndFabricSalesDetailPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerAndFabricSalesDetailPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerSalesData(input, responseCallBack, errorCallBack) {
    this.method("getCustomerSalesData", input, responseCallBack, errorCallBack);
  }
  static inquireMostRecentFabricDetailsForCustomer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireMostRecentFabricDetailsForCustomer",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireMostRecentCustomerSalesInvoiceInfo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireMostRecentCustomerSalesInvoiceInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printProformaInvoice(input, responseCallBack, errorCallBack) {
    this.method("printProformaInvoice", input, responseCallBack, errorCallBack);
  }
  static inquireFabricStyleInventoryValuationInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleInventoryValuationInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorPurchaseOrderData(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorPurchaseOrderData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireInventorySalesPurchasePositionResult(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInventorySalesPurchasePositionResult",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInventorySalesPurchasePositionReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInventorySalesPurchasePositionReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleSkuPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleSkuPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleSkuDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleSkuDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInvoicePaymentHistoryPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInvoicePaymentHistoryPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleInvoiceDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleInvoiceDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCertificateOfOriginInvoicePrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCertificateOfOriginInvoicePrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCommercialInvoicePrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCommercialInvoicePrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateDepositPrintOutReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateDepositPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceListForMonthsToDateSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceListForMonthsToDateSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static downloadPopUpManualCustomerAllocationPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "downloadPopUpManualCustomerAllocationPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleOtherInfoDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleOtherInfoDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateItemCatalogInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateItemCatalogInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchCustomerCurrentAgingMailDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchCustomerCurrentAgingMailDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendCustomerCurrentAgingMail(input, responseCallBack, errorCallBack) {
    this.method(
      "sendCustomerCurrentAgingMail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleWeeklyMonthlyATSResultReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleWeeklyMonthlyATSResultReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateBankAccountBalanceHistoryTrackPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateBankAccountBalanceHistoryTrackPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAccountReceivablePrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAccountReceivablePrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAccountReceivablePaymentHistoryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAccountReceivablePaymentHistoryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCreditMemoPrintReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateCreditMemoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInputWebFabricDataExportFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInputWebFabricDataExportFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static webFabricDataInputExcelUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "webFabricDataInputExcelUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricCriteriaExportInputFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricCriteriaExportInputFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateMutilWebFabricDataExportData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateMutilWebFabricDataExportData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static downloadPopUpItemOnOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "downloadPopUpItemOnOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static downloadPopUpCustomerOnOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "downloadPopUpCustomerOnOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateVendorPurchaseOnOrderDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateVendorPurchaseOnOrderDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSKUInventoryResultForSKUBasedPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSKUInventoryResultForSKUBasedPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricCriteriaExportInputFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricCriteriaExportInputFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateMutilWebFabricDataExportData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateMutilWebFabricDataExportData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireObseleteInventories(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireObseleteInventories",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateObseleteInventoriesPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateObseleteInventoriesPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleSoldInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleSoldInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleSoldPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleSoldPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleInvoiceDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleInvoiceDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSalesOrderStatusListDetailReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesOrderStatusListDetailReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesOrderStatusListDetailReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesOrderStatusListDetailReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerSalesOrderService(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCustomerSalesOrderService",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleYearlySalesReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleYearlySalesReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleYearlySalesPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleYearlySalesPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSalesOrderBackOrderDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesOrderBackOrderDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesBackOrderPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesBackOrderPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireInvoicedNotApprovedList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInvoicedNotApprovedList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInvoicedNotApprovedListReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInvoicedNotApprovedListReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickedNotInvoicedListReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePickedNotInvoicedListReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePostDatedChecksDetail(input, responseCallBack, errorCallBack) {
    this.method(
      "inquirePostDatedChecksDetail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickupSummaryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePickupSummaryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireMailtrackReport(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireMailtrackReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCashPaymentActivity(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireCashPaymentActivity",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCashPaymentActivityPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCashPaymentActivityPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSalesOrderListDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesOrderListDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesOrderListDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesOrderListDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerServiceSalesOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerServiceSalesOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerServiceReport(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireCustomerServiceReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerServicePrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerServicePrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePickedNotInvoicedList(input, responseCallBack, errorCallBack) {
    this.method(
      "inquirePickedNotInvoicedList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerServiceSalesOrderPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerServiceSalesOrderPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateVendorOnOrderPrintReport_dorell(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateVendorOnOrderPrintReport_dorell",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricSalesActivityPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricSalesActivityPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricSalesActivity(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireFabricSalesActivity",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFiscalYearBookingPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFiscalYearBookingPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFiscalYearBookingDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFiscalYearBookingDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerSalesAnalysisReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerSalesAnalysisReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesCommissionTransactionPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesCommissionTransactionPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireAllCustomerFabricStyleATSInfo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireAllCustomerFabricStyleATSInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAllFabricStyleCustomerATSInfoDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAllFabricStyleCustomerATSInfoDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerFabricStyleATSInfo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCustomerFabricStyleATSInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerFabricStyleATSInfoDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerFabricStyleATSInfoDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateWebInventoryReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateWebInventoryReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSKUInventoryBinSummaryReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSKUInventoryBinSummaryReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSKUBatchInventoryPhysicalVerificationTracks(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSKUBatchInventoryPhysicalVerificationTracks",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleInventoryValuationPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleInventoryValuationPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePurchaseOrderTransitInventoryCustomerAllocatedInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePurchaseOrderTransitInventoryCustomerAllocatedInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerAllocationInTransitInfosPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerAllocationInTransitInfosPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchHoldLocationInventoryPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchHoldLocationInventoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSkuBatchHoldLocationInventoryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSkuBatchHoldLocationInventoryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSkuBatchHoldLocationForInventoryAdjustmentPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSkuBatchHoldLocationForInventoryAdjustmentPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireReturnSalesCommissionDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireReturnSalesCommissionDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateReturnSalesPersonCommissionDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateReturnSalesPersonCommissionDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSalesCommissionDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireSalesCommissionDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesPersonCommissionDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesPersonCommissionDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSalesOrderRegisterDetailInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesOrderRegisterDetailInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesOrderRegisterDetailInfosReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesOrderRegisterDetailInfosReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireSalesOrderCancelLineDetailInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesOrderCancelLineDetailInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSalesOrderCancelLineDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesOrderCancelLineDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireOpenPickTicketDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireOpenPickTicketDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateOpenPickTicketPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateOpenPickTicketPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireBookingReportResultDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireBookingReportResultDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateBookingPrintReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateBookingPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireShippingReportResultDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireShippingReportResultDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateShippingPrintReport(input, responseCallBack, errorCallBack) {
    this.method(
      "generateShippingPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePickedandShippedList(input, responseCallBack, errorCallBack) {
    this.method(
      "inquirePickedandShippedList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickedandShippedListReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePickedandShippedListReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPickTicketPickerDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getPickTicketPickerDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickTicketPickerDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePickTicketPickerDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePullBulkPickTicketSummaryInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePullBulkPickTicketSummaryInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generatePullBulkPickTicketSummaryInquiryDetailReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePullBulkPickTicketSummaryInquiryDetailReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getCommercialInvoiceDetailsForMultipleInvoicesReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCommercialInvoiceDetailsForMultipleInvoicesReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePrintPickTicketInfos(input, responseCallBack, errorCallBack) {
    this.method(
      "inquirePrintPickTicketInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printPickedPickticketLineLabel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "printPickedPickticketLineLabel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printRemainingPickticketLineLabel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "printRemainingPickticketLineLabel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getWebEcomToErpWebImportFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getWebEcomToErpWebImportFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePullBulkPickTicketSummaryInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquirePullBulkPickTicketSummaryInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generatePullBulkPickTicketSummaryInquiryDetailReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generatePullBulkPickTicketSummaryInquiryDetailReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateSKUBatchInventoryPhysicalVerificationTrackReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSKUBatchInventoryPhysicalVerificationTrackReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateLogisticOrderReceiptPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateLogisticOrderReceiptPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateLogisticOrderPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateLogisticOrderPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireReportAllFabricStyleATSInfo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireReportAllFabricStyleATSInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireInboundOpenOrdersNotReceivedList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInboundOpenOrdersNotReceivedList",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateInboundOpenOrdersNotReceivedListReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInboundOpenOrdersNotReceivedListReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireInboundReceiptNotInvoicedList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInboundReceiptNotInvoicedList",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateInboundReceiptNotInvoicedListReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInboundReceiptNotInvoicedListReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleStatisticsSummaryDetailPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleStatisticsSummaryDetailPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleSalesPersonSalesSummaryDetailData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleSalesPersonSalesSummaryDetailData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleCustomerSalesSummaryDetailData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleCustomerSalesSummaryDetailData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleStatisticsSummaryDetailData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleStatisticsSummaryDetailData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleStatisticsSummaryData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleStatisticsSummaryData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCustomerStatementInquiryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerStatementInquiryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireCustomerStatementDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCustomerStatementDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateFabricStyleReceivedInquiryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleReceivedInquiryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleReceivedInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleReceivedInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireLatePurchaseOrderDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireLatePurchaseOrderDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateLatePurchaseOrderDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateLatePurchaseOrderDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireInventoryAdjustmentHistoryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInventoryAdjustmentHistoryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInventoryAdjustmentHistoryDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInventoryAdjustmentHistoryDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleSoldYearlyInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleSoldYearlyInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateInvoiceFabricStyleSoldYearlyInquiryDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInvoiceFabricStyleSoldYearlyInquiryDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquirePrintOutTrackReport(input, responseCallBack, errorCallBack) {
    this.method(
      "inquirePrintOutTrackReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireFabricStyleListWithPriceAndCostInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleListWithPriceAndCostInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateFabricStyleListWithPriceAndCostPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleListWithPriceAndCostPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getCreditMemoInquiryDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getCreditMemoInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateCreditMemoDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCreditMemoDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireMostRecentCustomerInfo(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireMostRecentCustomerInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getMostRecentCustomerDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getMostRecentCustomerDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireMostRecentCustomerSalesOrderInfo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireMostRecentCustomerSalesOrderInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireMostRecentCustomerSalesInvoiceInfo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireMostRecentCustomerSalesInvoiceInfo",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getMostRecentCustomerSalesinvoiceDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getMostRecentCustomerSalesinvoiceDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getMostRecentCustomerSalesOrderDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getMostRecentCustomerSalesOrderDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireCustomerDetailsWithSalesInvoiceInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireCustomerDetailsWithSalesInvoiceInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateCustomerDetailsWithSalesInvoiceReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCustomerDetailsWithSalesInvoiceReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateFabricStyleInventoryForLotBasedDetailsReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateFabricStyleInventoryForLotBasedDetailsReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricStyleBarCodePalletDetailsAndPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createFabricStyleBarCodePalletDetailsAndPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireFabricStyleBarCodePalletDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleBarCodePalletDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSkuInventoryTrackPrintOutReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSkuInventoryTrackPrintOutReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateBillOfLadingPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateBillOfLadingPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireInvoiceSerivceInquiryInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInvoiceSerivceInquiryInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateInvoiceSerivceDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInvoiceSerivceDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireInvoiceCommodityInquiryInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireInvoiceCommodityInquiryInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateInvoiceCommodityDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateInvoiceCommodityDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSalesPriceInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesPriceInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateSalesPriceInquiryDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesPriceInquiryDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireRollingInventories(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireRollingInventories",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateRollingInventoriesDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateRollingInventoriesDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireCpmDetailReport(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireCpmDetailReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireCpmDetailReport(input, responseCallBack, errorCallBack) {
    this.method(
      "inquireCpmDetailReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateCpmReportDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateCpmReportDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSalesAndPurchaseDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesAndPurchaseDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateSalesAndPurchaseDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSalesAndPurchaseDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireDailyInventoryTrackDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireDailyInventoryTrackDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDailyInventoryReceivedDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDailyInventoryReceivedDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDailyInventoryShippedDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDailyInventoryShippedDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDailyInventoryAdjustedDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDailyInventoryAdjustedDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inquireDailyInventoryProcessTrackDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireDailyInventoryProcessTrackDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDailyInvenotryPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDailyInvenotryPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDailyInvenotryAdjustedReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDailyInvenotryAdjustedReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDailyInvenotryShippedReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDailyInvenotryShippedReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDailyInvenotryReceivedReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDailyInvenotryReceivedReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDailyProcessInvenotryReceivedReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDailyProcessInvenotryReceivedReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricStyleInAndOutStatisticsDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleInAndOutStatisticsDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getLogisticOrdersReceiptsRollLinesForContainerNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getLogisticOrdersReceiptsRollLinesForContainerNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getLogisticOrderReceiptRollLinesForProjectNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getLogisticOrderReceiptRollLinesForProjectNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoicesRollLinesForContainerNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoicesRollLinesForContainerNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoicesRollLinesForProjectNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoicesRollLinesForProjectNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getPurchaseOrderReceiptRollLinesForLotNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptRollLinesForLotNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getInvoiceRollLinesForLotNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceRollLinesForLotNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getPickTicketRollLinesForContainerNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPickTicketRollLinesForContainerNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getPickTicketRollLinesForProjectNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPickTicketRollLinesForProjectNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPickTicketRollLinesForLotNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPickTicketRollLinesForLotNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricDashBoardDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardFabricSalesAnalysisDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardFabricSalesAnalysisDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardCustomerSalesAnalysisDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardCustomerSalesAnalysisDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardFabricAndCustomerSalesAnalysisDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardFabricAndCustomerSalesAnalysisDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardCustomerSummarySalesDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardCustomerSummarySalesDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardPurchaseDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricDashBoardPurchaseDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardPurchaseDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricDashBoardPurchaseDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardFabricPurchaseAnalysisDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardFabricPurchaseAnalysisDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardVendorPurchaseAnalysisDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardVendorPurchaseAnalysisDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardFabricAndVendorPurchaseAnalysisDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardFabricAndVendorPurchaseAnalysisDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardVendorSummaryPurchaseDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardVendorSummaryPurchaseDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardInBoundDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getDashBoardInBoundDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardOutBoundDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getDashBoardOutBoundDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateProformaInvoicePrintReportForPickTicket(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateProformaInvoicePrintReportForPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricStylePurchaseReceiptHistoryInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStylePurchaseReceiptHistoryInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getInvoicesForFabricStyleStatisticsForATS(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoicesForFabricStyleStatisticsForATS",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getPurchaseOrderReceiptDetailsForAts(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptDetailsForAts",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  //getFabricStyleInStatistics
  static getFabricStyleInStatistics(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleInStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  //getFabricStyleOutStatistics
  static getFabricStyleOutStatistics(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleOutStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardFabricSalesInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardFabricSalesInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardCustomerSalesInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardCustomerSalesInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateDashBoardSalesSkuDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardSalesSkuDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardTotalSalesPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardTotalSalesPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardFabricPurchaseDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardFabricPurchaseDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardVendorPurchaseInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardVendorPurchaseInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardPurchaseSkuDetailsPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardPurchaseSkuDetailsPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static generateDashBoardTotalPurchasePrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateDashBoardTotalPurchasePrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricStyleOutStatisticsInvoiceDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleOutStatisticsInvoiceDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardDetailsForCustomer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricDashBoardDetailsForCustomer",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardDetailsForLotNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricDashBoardDetailsForLotNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardDetailsForYear(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricDashBoardDetailsForYear",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricColorSatisticsSalesInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricColorSatisticsSalesInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricColorSatisticsInquiryPurchaseDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricColorSatisticsInquiryPurchaseDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getFabricDashBoardInventoryValuationDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricDashBoardInventoryValuationDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSummaryPurchaseOrderReportInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSummaryPurchaseOrderReportInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSummaryInvoiceReportInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSummaryInvoiceReportInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
  static inquireSalesAndPurchaseDetailsForFabricStyle(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSalesAndPurchaseDetailsForFabricStyle",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  
  static inquireFabricStyleSalesInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireFabricStyleSalesInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
static inquireSummaryPurchaseOrderReceiptReportInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSummaryPurchaseOrderReceiptReportInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSummarySalesOrderReportInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSummarySalesOrderReportInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSummaryPickTicketReportInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSummaryPickTicketReportInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static inquireSummaryCreditMemoReportInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "inquireSummaryCreditMemoReportInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  } 
  
 static generateSummaryPurchaseOrderInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSummaryPurchaseOrderInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSummaryPurchaseOrderReceiptInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSummaryPurchaseOrderReceiptInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSummarySalesOrderInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSummarySalesOrderInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSummaryPickTicketInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSummaryPickTicketInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSummaryInvoiceInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSummaryInvoiceInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateSummaryCreditMemoInfoPrintReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateSummaryCreditMemoInfoPrintReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
 static getFabricInventoryAndSalesAndPurchaseActivity(
    input,
    responseCallBack,
    errorCallBack
  ) {

    console.log("input",input);
      console.log("responseCallBack",responseCallBack);
        console.log("errorCallBack",errorCallBack);
    
    this.method(
      "getFabricInventoryAndSalesAndPurchaseActivity",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  
  static getSalesYearlyInquiryDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSalesYearlyInquiryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  
    static getProductCaltalog(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getProductCaltalog",
      input,
      responseCallBack,
      errorCallBack
    );
  }    

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.report_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(
        methodName,
        input,
        this.report_data_url,
        responseCallBack,
        errorCallBack
      );
    }
  }
}
